import type { Room } from 'livekit-client';

const POLL_INTERVAL_MS = 100;
const NO_VIDEO_GRACE_MS = 500;
const START_TIMEOUT_MS = 3000;

async function hasDecodedVideo(room: Room): Promise<boolean> {
    const videoTracks = [...room.remoteParticipants.values()].flatMap((participant) =>
        [...participant.videoTrackPublications.values()].flatMap((publication) =>
            publication.videoTrack ? [publication.videoTrack] : []
        )
    );
    const reports = await Promise.all(videoTracks.map((track) => track.getRTCStatsReport()));
    return reports.some((report) =>
        [...(report?.values() ?? [])].some(
            (stats: RTCStats) => stats.type === 'inbound-rtp' && ((stats as RTCInboundRtpStreamStats).framesDecoded ?? 0) > 0
        )
    );
}

export async function waitForMedia(room: Room, signal: AbortSignal): Promise<void> {
    const startedAt = Date.now();
    while (!signal.aborted) {
        const elapsed = Date.now() - startedAt;
        if (elapsed >= START_TIMEOUT_MS) return;
        const hasPublishedVideo = [...room.remoteParticipants.values()].some(
            (participant) => participant.videoTrackPublications.size > 0
        );
        if (!hasPublishedVideo && elapsed >= NO_VIDEO_GRACE_MS) return;
        if (await hasDecodedVideo(room)) return;
        await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
    }
}
